module.exports = __webpack_public_path__ + "fonts/Gilroy-600.5b057a2.otf";